export type AdminEmailChangeStep = "request" | "pending";

export interface AdminEmailChangeFormData {
  newEmail: string;
}

export const adminEmailChangeErrorMessage = (error: unknown): string => {
  const status =
    typeof error === "object" && error !== null && "status" in error
      ? Number((error as { status?: unknown }).status)
      : undefined;
  if (status === 403) return "You do not have permission to change this user's email address.";
  if (status === 404) return "This user could not be found.";
  if (status === 409) return "This email change cannot be started for the user right now.";
  if (status === 429) return "Too many attempts. Wait before trying again.";
  return "The email change request could not be started. Try again.";
};
